import axios from 'axios';
import { API_ENDPOINTS } from '../../config/api';

export const getToken = () => sessionStorage.getItem('adminToken');

export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const adminApi = {
  get: (url) => axios.get(url, { headers: authHeaders() }),
  post: (url, data, extraHeaders) => axios.post(url, data, { headers: { ...authHeaders(), ...extraHeaders } }),
  put: (url, data) => axios.put(url, data, { headers: authHeaders() }),
  del: (url) => axios.delete(url, { headers: authHeaders() }),
};

export { API_ENDPOINTS };
